import { Map } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { WorkDayMapper } from "features/planner/planner.mappers";

const initialState = Map();

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_WORK_DAYS_BY_EMPLOYEE: {
      if (error) return state;

      return Map(
        payload.map(WorkDay => {
          const workDay = WorkDayMapper.from(WorkDay);

          return [
            workDay
              .get("date")
              .startOf("day")
              .toISOString(),
            workDay,
          ];
        }),
      );
    }

    default:
      return state;
  }
};
